import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            companies: [],
            currentDate: new Date(),
            currentWeek: '',
            week: [],
            showAddDefinition: false,
            showChooseDefinition: false,
            addDefinitionDate: '',
            definitionDataToEdit: null,
            chooseDefinitionDate: '',
            startDate: '',
            endDate: '',
            copyTrainingForDate: false,
            copyTrainingForDateItem: null
        }
    },
    methods: {
        getStartOfWeek: getStartOfWeek,
        formatDate: formatDate,
        editDefinitionData: editDefinitionData,
        displayWeek: displayWeek,
        deleteTrainingOfTheDay: deleteTrainingOfTheDay,
        getTrainingOfTheDayForPeriod: getTrainingOfTheDayForPeriod,
        showDefinitionAdd: showDefinitionAdd,
        allWodTrainings: allWodTrainings,
        seeWodAsUser: seeWodAsUser,
        changeWeek: changeWeek,
        getName: getName,
        getShortDesc: getShortDesc,
        getLongDesc: getLongDesc,
        copyTrainingForDates: copyTrainingForDates
    },

    created() {

        this.$topnavbar.$on('closeTrainingDefinition', () => {
            this.addDefinitionDate = ''
            this.showAddDefinition = false
        });

        this.$topnavbar.$on('successTrainingDefinition', () => {
            this.addDefinitionDate = ''
            this.showAddDefinition = false
            this.getTrainingOfTheDayForPeriod();
        });

        this.$topnavbar.$on('chooseExistTraining', (data) => {
            this.addDefinitionDate = ''
            this.showAddDefinition = false
            this.showChooseDefinition = true
            this.chooseDefinitionDate = data
        });

        this.$topnavbar.$on('closeChooseDefinition', () => {
            this.showChooseDefinition = false
            this.chooseDefinitionDate = ''
        });

        this.$topnavbar.$on('onTrainingDefinitionSelected', (data) => {
            this.showChooseDefinition = false
            this.chooseDefinitionDate = ''
            this.getTrainingOfTheDayForPeriod();
        });

        this.$topnavbar.$on('closeCopyTraining', () => {
            this.copyTrainingForDate = false
            this.copyTrainingForDateItem = null
        });

        this.$topnavbar.$on('successCopyTraining', () => {
            this.copyTrainingForDate = false
            this.copyTrainingForDateItem = null
            this.getTrainingOfTheDayForPeriod();
        });

    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.role = session.getRole();
        this.displayWeek();
    }
}

function copyTrainingForDates(item){
    this.copyTrainingForDate = true;
    this.copyTrainingForDateItem = item;
}

function showDefinitionAdd(item){
    this.definitionDataToEdit = null
    this.addDefinitionDate = item.date
    this.showAddDefinition = true
}

function editDefinitionData(item){
    this.definitionDataToEdit = item
    this.addDefinitionDate = item.date
    this.showAddDefinition = true
}

function getStartOfWeek(date) {
    const day = date.getDay();
    const diff = date.getDate() - day + (day === 0 ? -6 : 1); // Adjust when day is Sunday
    return new Date(date.setDate(diff));
}

// Funkcija za formatiranje datuma
function formatDate(date) {
    console.log(date);
    return this.$moment(date).format('DD-MM-YYYY')
    // return date.toLocaleDateString('en-GB', {
    //     day: '2-digit',
    //     month: '2-digit',
    //     year: 'numeric'
    // });
}


// Funkcija za prikaz trenutne nedelje u kontejnerima
function displayWeek() {

    const startOfWeek = getStartOfWeek(new Date(this.currentDate));
    this.week = [];
    for (let i = 0; i < 7; i++) {
        const currentDay = new Date(startOfWeek);
        currentDay.setDate(startOfWeek.getDate() + i);
        this.week.push({
            date: this.formatDate(currentDay),
            details: []
        })
        // weekContainer.children[i].textContent = formatDate(currentDay);
    }

    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    this.startDate = this.formatDate(startOfWeek);
    this.endDate = this.formatDate(endOfWeek);
    this.currentWeek = ` ${this.startDate} - ${this.endDate}`;
    this.getTrainingOfTheDayForPeriod();
}

// Funkcija za promenu nedelje
function changeWeek(offset) {
    this.week = [];
    this.currentDate.setDate(this.currentDate.getDate() + offset * 7);
    this.displayWeek();
}

function getTrainingOfTheDayForPeriod(){
    let model = {
        fromDate: this.startDate,
        toDate: this.endDate,
        type: "WOD"
    }

    AdminApiService.getTrainingOfTheDayForPeriod(model)
        .then((response) => {
            this.week.forEach(w => {w.details = [];})
            response.data.forEach(dateObj => {

                const item = this.week.find(entry => entry.date === dateObj.date);
                if (item) {
                    item.details.push(dateObj);
                }
            });
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}


function getName(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.name;
    }else if(item.enName != null && item.enName.length > 0){
        return  item.enName;
    }
    return item.name;
}

function getShortDesc(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.shortDescription;
    }else if(item.enShortDescription != null && item.enShortDescription.length > 0){
        return  item.enShortDescription;
    }
    return item.shortDescription;
}

function getLongDesc(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.longDescription;
    }else if(item.enLongDescription != null && item.enLongDescription.length > 0){
        return  item.enLongDescription;
    }
    return item.longDescription;
}

function deleteTrainingOfTheDay(item){
    let _self = this;
    swal({
        title: LocService.t("label_delete_training_of_the_day"),
        text: LocService.t("label_delete_training_of_the_day_are_you_sure") + ": " + this.getName(item),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t("label_no"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t("label_yes"),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteTrainingOfTheDay(item.id)
            .then((response) => {
                swal(LocService.t("label_success"), LocService.t('label_delete_training_of_the_day_successfully'), 'success')
                _self.getTrainingOfTheDayForPeriod();
            })
            .catch(error => {
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })

    })
}

function allWodTrainings(){
    this.$router.push('/all-wod-trainings');
}

function seeWodAsUser(){
    window.open('http://localhost:3010/#/wod-program?programToken='+session.getAccessToken(), '_blank');

}


// WEBPACK FOOTER //
// ./src/components/Wod/Wod.js